/**
 * Whether `value` can be used as a demo URL — a parseable http(s) URL.
 *
 * Shared by `setDemoUrl` (which enforces it) and `EditDemoUrlDialog` (which
 * uses it to gate the Apply button). The thunk is exported on
 * `ExperienceBuilderAction`, so the dialog cannot be the only check: an
 * unparseable value would set `demoUrl` — flipping `isAuthenticated` and the
 * whole builder into demo mode — while `getDemoOrigin` returned undefined,
 * leaving the Shopify tools with no origin to work from.
 */
export function isValidDemoUrl(value: string): boolean {
  try {
    const { protocol } = new URL(value);
    return protocol === "http:" || protocol === "https:";
  } catch {
    return false;
  }
}
